import { usergroup_ids } from "store/portal";

export const validateVisibleForUsergroup = (item) => {
	if (!item.extra.workflowusergroup.length) {
		return true;
	} else {
		const usergroupIds = item.extra.workflowusergroup.map(a => a.id);
		return usergroupIds.some(id => usergroup_ids.value.includes(id));
	}
};